<template>
  <div class="card-mobile-container">
    <div
      class="card-mobile"
      :key="`mobile-card-${plan.id}`"
      :id="`mobile-card-${plan.id}`"
    >
      <div class="card-mobile-closed">
        <div class="card-mobile-closed__plan">
          <h2>{{ plan.franchise + plan.bonus }}GB</h2>
          <h3 v-show="!isOpen">{{ plan.franchise }}GB + {{ plan.bonus }}GB</h3>
        </div>
        <div class="card-mobile-closed__price" v-show="!isOpen">
          <h3>
            {{
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(plan.price)
            }}
          </h3>
          <small>/mês</small>
        </div>
        <div v-show="!isOpen">
          <button
            type="button"
            :class="isOpen ? 'mdn-Icon-cima' : 'mdn-Icon-baixo'"
            class="mdn-Icon--md"
            @click.prevent="$emit('OpenPlanMobile')"
          ></button>
        </div>
        <transition name="slide-fade">
          <div v-show="isOpen">
            <PlanDescription
              :text="plan.name"
              class="plan-description-container"
            />
          </div>
        </transition>
      </div>
      <transition name="slide-fade">
        <div class="card-mobile-open" v-show="isOpen">
          <CardCommon :plan="plan" :more-advantages-open="moreAdvantagesOpen" />
          <PlanSubtitle
            :text="plan.includeTitle"
            class="pb-2"
            v-show="moreAdvantagesOpen"
          />
          <div
            v-if="plan.skeelo"
            v-on:click="openInfo(plan)"
            class="skeelo w-100"
            tabindex="0"
            :title="String($t('accessibilityTexts.title.cardPlan.skeelo'))"
            @keyup.enter="openInfo(plan)"
            v-show="moreAdvantagesOpen"
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                cursor: pointer;
              "
            >
              <div style="display: flex; align-items: center">
                <img
                  style="width: 40px"
                  src="https://mondrian.claro.com.br/brands/app/partners/72px-default/skeelo.svg"
                  alt="Skeelo"
                  title="Skeelo"
                />
                <p
                  v-if="plan.id === '929d4daa-b0cb-4be9-9eba-10ba530c2535'"
                  style="margin-top: 15px; margin-left: 15px"
                >
                  Skeelo light
                </p>
                <p v-else style="margin-top: 15px; margin-left: 15px">Skeelo</p>
              </div>
              <span
                style="color: red; margin-top: 10px"
                class="mdn-Icon-informacao mdn-Icon--md"
              ></span>
            </div>
            <div v-if="info">
              <br />
              Livros digitais by Skeelo é uma plataforma de leitura com eBooks
              mais vendidos nas livrarias diretamente no seu celular, um novo
              ebook por mês.
            </div>
          </div>
          <div class="more-advantages-button-container">
            <button
              type="button"
              @click.prevent="moreAdvantagesOpen = !moreAdvantagesOpen"
            >
              <span v-if="moreAdvantagesOpen"
                >Fechar vantagens <i class="mdn-Icon--md mdn-Icon-cima" />
              </span>
              <span v-else
                >Mais vantagens <i class="mdn-Icon--md mdn-Icon-baixo"
              /></span>
            </button>
          </div>
          <Cupom
            :catalog-id="plan.catalogId"
            :planId="plan.id"
            :coupon-code="plan.coupon"
            :franchise="plan.franchise"
            :bonus="plan.bonus"
            @success="onSuccessCupom"
            v-if="!couponOff"
            class="mt-3 w-100"
          />
          <div class="plan-values-list mt-3">
            <p>
              <span>Valor do plano:</span>
              <span class="plan-price"
                >R$ {{ String(plan.price).replace(".", ",") }}</span
              >
            </p>
            <p v-if="!couponOff">
              <span>Valor do desconto:</span>
              <span class="plan-discount"
                >- R$ {{ discounts.replace(".", ",") }}</span
              >
            </p>
          </div>
          <div class="plan-first-month mdn-Text" v-if="off">
            <p>
              <span>R$</span>
              {{ off < 0 ? "0,00" : off.replace(".", ",") }}
            </p>
            <p class="plan-first-month-warning">no primeiro mês</p>
          </div>
          <div class="plan-buttons">
            <button
              class="mdn-Button mdn-Button--primary mdn-Button--lg mdn-Button--block"
              :title="mountPlanTitle(plan)"
              @click="$emit('register', { plan, couponSelected })"
              :id="plan.id"
            >
              Quero esse
            </button>
          </div>
          <div class="plan-details">
            <button
              type="button"
              class="plan-details-btn-link"
              @click.prevent="openDetails(plan)"
              :title="
                String($t('accessibilityTexts.title.cardPlan.moreDetails'))
              "
            >
              Mais detalhes
              <i class="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></i>
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import PlanTitle from "@/components/PlanTitle/index.vue";
import PlanSubtitle from "@/components/PlanSubtitle/index.vue";
import PlanDescription from "@/components/PlanDescription/index.vue";
import { CardPlanMixin } from "@/mixins/CardPlan.mixin";
import Cupom from "@/components/core/Cupom.vue";
import CardCommon from "@/components/Swiper/CardCommon.vue";
import { Prop } from "vue-property-decorator";

@Component({
  name: "CardMobile",
  components: {
    CardCommon,
    Cupom,
    PlanDescription,
    PlanSubtitle,
    PlanTitle,
  },
})
export default class CardMobile extends mixins(Vue, CardPlanMixin) {
  @Prop({ required: false }) isOpen!: boolean;
  moreAdvantagesOpen = false;
}
</script>

<style lang="scss">
.card-mobile-container {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;

  .card-mobile {
    width: 90%;
    height: auto;
    padding: 14px 20px 14px 20px;
    border-radius: 8px;
    justify-content: space-between;
    margin: 10px auto;
    font-family: Roboto, sans-serif;
    background: linear-gradient(0deg, #f8f8f8, #f8f8f8),
      linear-gradient(0deg, #d4d7de, #d4d7de);
    border: 1px solid #d4d7de;

    .card-mobile-closed {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;

      .card-mobile-closed__plan {
        h2 {
          font-size: 34px;
          line-height: 34px;
          font-weight: 700;
          color: #da291c;
          padding: 0 15px 0 0;
          margin: 0;
        }
        h3 {
          width: 90px;
          font-size: 16px;
          line-height: 20px;
          font-weight: 700;
          color: #51555d;
          padding: 0;
          margin: 0;
        }
      }

      .card-mobile-closed__price {
        margin-top: 5px;
        text-align: right;
        h3 {
          font-size: 24px;
          line-height: 24px;
          font-weight: 700;
          color: #000000;
          padding: 0;
          margin-bottom: -5px;
        }
        small {
          font-size: 13px;
          line-height: 13px;
          font-weight: 400;
          color: #51555d;
          padding: 0;
          margin: 0;
        }
      }
    }
  }

  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  .plan-details {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 24px auto 19px auto;

    .plan-details-btn-link {
      width: 150px;
      height: 30px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      padding: 0;

      text-align: center;
      font-weight: 500;
      font-size: 16px;
      line-height: 21px;
      color: #000000;

      i {
        height: 30px;
        padding: 0;
      }
    }
  }
}

.more-advantages-button-container {
  width: 100%;
  height: 24px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 24px auto;

  button {
    span {
      vertical-align: middle;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;

      i {
        vertical-align: bottom;
      }
    }
  }
}

.plan-first-month {
  width: 100%;
  margin-top: 28px;
  p {
    font-weight: 700;
    font-size: 48px;
    line-height: 30px;
    margin-bottom: 0;

    text-align: center;

    color: #e02020;

    span {
      font-size: 24px;
    }

    i {
      color: #e02020;
    }
  }

  .plan-first-month-warning {
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;

    text-align: center;

    color: #000000;
  }
}

.mdn-Icon-informacao {
  &:before {
    color: #d4d7de;
  }
}
</style>
